// Pure wrapper around provided exportDataGridToPdf behavior, but restores your original styling precisely

const { jsPDF } = window.jspdf;
import { exportDataGrid as exportDataGridToPdf } from "devextreme/pdf_exporter";
import { addHeaderFooterToDoc } from './pdfHeaderFooter';
import { createCellCustomizer } from './cellCustomizerPdf';
import { PDF_STYLES } from './pdfStyles';

// eslint-disable-next-line no-unused-vars
export async function exportAsPdf({ e, fileName, grid, finalColumnsForExport, formatCellValue, options, exportVisibilityMap }) {
    let lastPage = 1;
    const FIRST_PAGE_HEADER_HEIGHT = 40; // taller for letterhead
    const OTHER_PAGE_HEADER_HEIGHT = 20; // smaller for normal pages
    const orientationPoint = 8;


    let visibleColumns = finalColumnsForExport.filter((col) => col.visible);
    // visibleColumns can have move columns in one element attached to it, so we need to flatten it
    const flattenColumns = (cols) => {
        let flat = [];
        cols.forEach((col) => {
            if (col.columns && Array.isArray(col.columns)) {
                flat = flat.concat(flattenColumns(col.columns));
            } else {
                flat.push(col);
            }
        });
        return flat;
    };
    const visibleCount = flattenColumns(visibleColumns).length;


    const doc = new jsPDF({
        orientation: visibleCount > orientationPoint ? 'landscape' : 'portrait',
        unit: 'pt',
        format: 'a4',
        compress: true,
    });


    addHeaderFooterToDoc(doc, fileName, options);


    const visibleCols = finalColumnsForExport.filter((c) => c.visible);
    const LEFT_MARGIN = PDF_STYLES.leftMargin;
    const RIGHT_MARGIN = PDF_STYLES.rightMargin;


    const pageWidth = doc.internal.pageSize.getWidth();
    const usablePageWidth = pageWidth - LEFT_MARGIN - RIGHT_MARGIN;
    const fittedColWidth = usablePageWidth / Math.max(1, visibleCols.length);


    const cellCustomizer = createCellCustomizer({ formatCellValue });


    // DevExtreme 22.x pdf_exporter does not support customizeColumns.
    // Instead, temporarily hide excluded columns via columnOption() — a targeted per-column
    // update that does NOT trigger a server re-fetch (unlike replacing the full columns array).
    // beginUpdate/endUpdate suppresses any visual re-render during the mutation.
    const hiddenForExport = [];
    const needsEndUpdate = !!exportVisibilityMap;
    if (needsEndUpdate) grid.beginUpdate();

    try {
        if (exportVisibilityMap) {
            const colCount = grid.columnCount ? grid.columnCount() : 0;
            for (let i = 0; i < colCount; i++) {
                const dataField = grid.columnOption(i, 'dataField');
                if (!dataField) continue; // skip band headers
                const shouldExport = exportVisibilityMap.has(dataField)
                    ? exportVisibilityMap.get(dataField)
                    : false;
                if (!shouldExport && grid.columnOption(i, 'visible') !== false) {
                    hiddenForExport.push(i);
                    grid.columnOption(i, 'visible', false);
                }
            }
        }

        await exportDataGridToPdf({
            jsPDFDocument: doc,
            component: e.component,
            topLeft: { x: LEFT_MARGIN, y: 2 },
            columnWidths: () => fittedColWidth,
            customizeCell: cellCustomizer,
            customDrawCell({ rect }) {
                if (!rect) return;


                const currentPage = doc.internal.getCurrentPageInfo().pageNumber;
                const headerOffset = currentPage === 1 ? FIRST_PAGE_HEADER_HEIGHT : OTHER_PAGE_HEADER_HEIGHT;


                if (currentPage !== lastPage) {
                    lastPage = currentPage;
                    rect.y += headerOffset;
                }
            },
        });
    } finally {
        // Restore temporarily hidden columns and release visual update batching
        hiddenForExport.forEach((i) => grid.columnOption(i, 'visible', true));
        if (needsEndUpdate) grid.endUpdate();
    }


    doc.save(`${fileName}.pdf`);
}